import { ControllerFlowAPI, Experiments } from '@wix/yoshi-flow-editor';
import { FormApi } from '../../../api/FormApi';
import { EmptyStateErrorType } from '../../../types/errors';
import { BusinessInfo } from '../../../types/types';
import { createDummyState } from '../../dummies/dummy-data';
import { IFlowApiAdapter } from '../../flow-api-adapter/types';
import { DEFAULT_FORM_ID } from '../getFormId/getFormId';
import { isCartEnabled } from '../utils/utils';

export async function getDummyData(
  formApi: FormApi,
  wixSdkAdapter: IFlowApiAdapter,
  flowApi: ControllerFlowAPI,
  experiments: Experiments,
) {
  const dummyBusinessInfo: BusinessInfo = {
    regionalSettingsLocale: 'en',
    dateRegionalSettingsLocale: 'en-US',
    isSMSReminderEnabled: false,
    countryCode: 'US',
    name: 'Dummy Business',
    language: 'en',
    currency: 'USD',
    timeZone: 'America/New_York',
    isMultiServicesAppointmentsEnable: false,
  };
  const [
    catalogData,
    isPricingPlanInstalled,
    isMemberAreaInstalled,
    isUpsellPluginInstalled,
  ] = await Promise.all([
    wixSdkAdapter.isA11YWizardMode()
      ? Promise.resolve({ businessInfo: dummyBusinessInfo })
      : formApi.getCatalogData(),
    wixSdkAdapter.isPricingPlanInstalled().catch(() => false),
    formApi.isMembersAreaInstalled(),
    formApi.isUpsellPluginInstalled(),
  ]);

  if (!catalogData) {
    throw EmptyStateErrorType.INVALID_CATALOG_DATA;
  }

  const [isSMSAutomationsEnabled] = await Promise.all([
    formApi.isSMSAutomationsEnabled({
      businessInfo: catalogData.businessInfo,
    }),
    formApi.initWixFormController({ formId: DEFAULT_FORM_ID }),
  ]);

  const isMultiServicesAppointmentsEnable =
    catalogData.businessInfo.isMultiServicesAppointmentsEnable;

  return createDummyState({
    flowApi,
    businessInfo: catalogData.businessInfo,
    isMemberAreaInstalled,
    isPricingPlanInstalled,
    isMultiServicesAppointmentsEnable,
    isUpsellPluginInstalled,
    isSMSAutomationsEnabled,
    isCart: await isCartEnabled({
      experiments: flowApi.experiments,
      wixSdkAdapter,
      businessInfo: catalogData!.businessInfo,
    }),
    experiments,
  });
}
